module.exports = __webpack_public_path__ + "static/media/RecomendaUberlandia.fdd8246f.jpg";